import React from 'react';
import { Container, Row } from 'reactstrap';
import BasicTableClass from './BasicTableClass';
import InverseTableClass from './InverseTableClass';
import HoverableRowsClass from './HoverableRows';
import StripeInverseClass from './StripInverseClass';
import CaptionClass from './Caption';
import ResponsiveClass from './ResponsiveClass';
import BreckpointClass from './BreckpointClass';
import TableHeadClass from './TableHeadClass';
import { Breadcrumbs } from '../../../../AbstractElements';
import InversePrimaryClass from './InversTableClass';
import Sizingtable from './Sizingtable';
import CustomHoverClass from './CustomeHover';
import DashedBorderClass from './DashedBorderClass';

const BasicTablesContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs title='Bootstrap Basic Tables' pageTitle='Bootstrap Basic Tables' parent='Bootstrap Tables' />
      <Row className='basic_table'>
        <BasicTableClass />
        <InverseTableClass />
        <HoverableRowsClass />
        <InversePrimaryClass />
        <CaptionClass />
        <TableHeadClass />
        <StripeInverseClass />
        <BreckpointClass />
        <ResponsiveClass />
        <Sizingtable />
        <CustomHoverClass />
        <DashedBorderClass />
      </Row>
    </Container>
  );
};

export default BasicTablesContainer;
